import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React, { Fragment } from 'react';
import { Check } from '@finect/tabular-icons/check';
import { withTheme } from 'styled-components';
import { Section } from '../../Section';
import { getTableCells } from '../ProductsTable/utils';
import { fieldsByProductType } from '../fieldsByProductType';
import { HighlightContent, Highlight, Title, Subtitle, Summary } from './partials';
export var ProductHighlights = function ProductHighlights(_ref) {
  var product = _ref.product,
    theme = _ref.theme,
    actions = _ref.actions,
    productsSubscriptions = _ref.productsSubscriptions;
  var subtype = product.subtype,
    entity = product.entity;
  var fieldsDefinition = fieldsByProductType.find(function (item) {
    return item.productType === subtype;
  });
  var fields = fieldsDefinition.highlightFields || [];
  var promotion = entity.promotion || '';
  var cells = getTableCells({
    fields: fields,
    product: product,
    theme: theme,
    actions: actions,
    productsSubscriptions: productsSubscriptions
  });
  return React.createElement(Section, {
    bottomMargin: true
  }, React.createElement(HighlightContent, {
    leftMargin: cells.length && promotion.length
  }, cells.length ? React.createElement(Highlight, null, React.createElement(Title, null, "Destacamos"), cells.map(function (cell, index) {
    var meta = cell.meta,
      component = cell.component;
    var tooltip = meta.column.tooltip;
    var description = tooltip ? tooltip.text : meta.field.label;
    return React.createElement(Fragment, {
      key: index
    }, React.createElement(Subtitle, null, component), React.createElement(Summary, null, description));
  })) : null, entity && promotion.length ? React.createElement(Highlight, null, React.createElement(Title, {
    isPromotion: true
  }, "Promociones"), React.createElement(Subtitle, {
    isPromotion: true
  }, React.createElement(Check, null), React.createElement("span", null, entity.promotion))) : null));
};
export default withTheme(ProductHighlights);